<template>
<div>

    <nav-bar>
        <div slot="title">{{langText.orderDetailsPage}}</div>
        <div slot="left">
            <van-icon name="arrow-left" color="#666666" size="20" @click="goBack"/>
        </div>
    </nav-bar>
    <div style="height: 50px">

    </div>
    <div id="orderDetail">
            <van-cell-group inset>
                <van-cell :title="langText.good" value="" />
                   <van-cell>
                    <van-card
                            :num="goodsItem.productQuantity"
                            :price="goodsItem.productPrice"
                            :desc="getProductDesc(goodsItem.productAttr)"
                            :title="goodsItem.productName"
                            :thumb="goodsItem.productPic"
                            v-for="(goodsItem, goodsIndex) of order.orderItemList"
                            @click="buyAgain(goodsItem.productId)"/>

                    </van-cell>
                <van-cell :title="langText.orderStatus" :value="order.status" />
                <van-cell :title="langText.orderAmount" :value="order.payAmount" />

                <van-cell v-if="judgeState(this.$route.query.status)" :title="langText.changingOrRefund"  @click="salesreturn">
                    <van-button plain type="info" size="4" style="height: 25px; width: 150px"><span style="font-size: 8px">{{langText.changingOrRefundhit}}</span></van-button>
                </van-cell>
            </van-cell-group>
        <!--这是订单的产品-->
        <br/>

        <van-cell-group inset>
            <van-cell-group inset>
                <van-cell :title="langText.orderReference" :value="order.orderSn" />
                <van-cell :title="langText.creationTime" :value="order.createTime"/>
                <van-cell :title="langText.creationTime" :value="order.createTime"/>
            </van-cell-group>
        </van-cell-group>
        <br/>
        <van-cell-group inset>
            <van-cell-group inset>
                <van-cell :title="langText.addresseeRegion" :value="order.region" />
                <van-cell :title="langText.direction" :value="order.address"  />
                <van-cell :title="langText.addresseeName" :value="order.receiverName" />
                <van-cell :title="langText.phoneNumber" :value="order.receiverPhone"  />
            </van-cell-group>
        </van-cell-group>
    </div>
    <div style="height: 20px">
    </div>

</div>

</template>

<script>
    import {Tabs, Tab, Icon, Card, Button, Toast, List, PullRefresh, Popup, Divider, CheckboxGroup, Cell, CellGroup} from 'vant';
    import NavBar from "@/components/common/navbar/NavBar";
    import {verifyOrder, getOrderDetail} from "../../network/order/order.js"

    import { langPackage } from "@/config/lang/orderDetailLang";
    import { selectLang } from "@/config/setLanguage";

    export default {
        name: "OrderDetail",
        data(){
            return{
                order:{
                    //数量
                    orderSn:"",
                    num:2,
                    payAmount:100,
                    status:"",
                    title:'这是标题',
                    thumb:'这是图片',
                    orderItemList:[],
                    createTime:'',
                    region:'',
                    address:'',
                    receiverName:"",
                    receiverPhone:"",
                },
                langText: {},
                commonText:{},
                lang: "cn"
            }

        },
        components: {
            NavBar: NavBar,
            [Icon.name]: Icon,
            [Card.name]: Card,
            [Cell.name]: Cell,
            [CellGroup.name]: CellGroup,
            [Toast.name]: Toast,
            [Button.name]: Button,
        },
        methods:{
            goBack(){
                //默认返回单全部
                this.$router.push('/order/personalOrders');
            },
            salesreturn(){
                this.$router.push({path:'/order/returnedGoods',
                    query:{
                    orderSn: this.order.orderSn,
                     status: this.$route.query.status,
                         id: this.$route.query.id
                    }
                });
            },
            buyAgain(product){
                this.$router.push('/goods/goodsInfo/'+product);
            },
            setStatus(status){
                switch (status) {
                    case '0':
                        this.order.status = this.commonText.waitForPayment;
                        break;
                    case '1':
                        this.order.status = this.commonText.waitForSend;
                        break;
                    case '2':
                        this.order.status = this.commonText.delivered;
                        break;
                    case '3':
                        this.order.status = this.commonText.completed;
                        break;
                    case '4':
                        this.order.status = this.commonText.canceled;
                        break;
                    case '5':
                        this.order.status = this.commonText.invalidOrders;
                        break;

                }
            },
            judgeState(status){
                if (status == 1 || status == 2 || status == 3){
                    return true;
                }
                return false
            },
            getProductDesc(productArr){
                let str = '';
                if(productArr == null){
                    return str
                }
                let arr = JSON.parse(productArr);
                for(let $i = 0; $i < arr.length; $i++) {
                    str += arr[$i]['key'] + ':' + arr[$i]['value']
                    if ($i != arr.length -1){
                        str += ' / ';
                    }
                }
                return str;
            }

        },//网络请求
        created() {
            //获取语言包
            selectLang(langPackage).then(langtxt =>{
                this.langText = langtxt.langtxt;
                this.commonText = langtxt.common;

                //获取订单的orderid
                let data = {
                    orderSn: this.$route.query.orderSn,
                    //传入状态0为 待付款状态
                    status: this.$route.query.status
                };
                let id =  this.$route.query.id;
                this.setStatus(this.$route.query.status);

                //获取订单的状态
                //获取订单的id 并且验证是否是你的订单
                verifyOrder(data).then(res => {
                    //获取订单的信息 以及付款信息
                    if (res.code == 200){
                        this.order.orderSn = res.data.orderSn;
                        this.order.payAmount = res.data.payAmount;
                        //设置支付方式
                        getOrderDetail(id).then(res=>{
                            if (res.code == 200){
                                //存放商品的数据
                                this.order.orderItemList = res.data.orderItemList;
                                this.order.createTime = res.data.createTime.split("T")[0];

                                //地址
                                this.order.region = res.data.receiverProvince+"/"+res.data.receiverCity+"/"+res.data.receiverRegion;
                                this.order.address = res.data.receiverDetailAddress;

                                //收件人 电话
                                this.order.receiverName = res.data.receiverName;
                                this.order.receiverPhone = res.data.receiverPhone;
                            }
                        })
                    }
                })

            });


        }
    }
</script>

<style scoped>
    @import "~@/assets/css/index/style.css";
    .van-nav-bar {
        box-shadow: 0px 1px 3px 0px rgba(0,0,0,.5);
        background-color: #ffffff;
    }

    #orderDetail{
        background: #f8f6f7;
    }

</style>
